Object.defineProperty(exports, '__esModule', { value: true });

var rules = function (blockClass) { return [
    ".".concat(blockClass, " { background: currentColor }"),
    'noscript { display: none !important; }',
]; };

exports.default = rules;
//# sourceMappingURL=inject-style.js.map
